import url from './url';

function compare(obj, obj2) {
    return JSON.stringify(obj) === JSON.stringify(obj2);
}

export default class Router {
    constructor(routes, aliases, defaultUrl, onChange, onAlias) {
        this.routes = routes;
        this.aliases = aliases;
        this.defaultUrl = defaultUrl;
        this.onChange = onChange;
        this.onAlias = onAlias;

        this.mapUrlsToRoutes();
        this.initialize();
    }

    initialize() {
        this.updateFromBrowser();

        url.on('qs', () => this.updateFromBrowser());
        url.on('path', () => this.updateFromBrowser());

        if (!this.urls[this.defaultUrl]) {
            throw new Error('Incorrect default URL for router!');
        }
    }

    handleAlias() {
        if (!this.onAlias) {
            return;
        }

        let routes = this.aliases[this.route];

        if (routes) {
            routes.forEach((alias) => {
                let params = {};

                if (alias.parameters) {
                    alias.parameters.forEach(x => params[x] = this.parameters[x]);
                }

                this.onAlias(alias.route, params);
            });
        }
    }

    updateFromBrowser() {
        this.setUrl(url.getPath(), url.getQueryString());
    }

    mapUrlsToRoutes() {
        this.urls = {};

        Object.keys(this.routes).forEach((key) => {
            this.urls[this.routes[key]] = key;
        });
    }

    setUrl(path, parameters) {
        if (this.urls[path]) {
            this.setRoute(this.urls[path], parameters, true);
        } else {
            this.setUrl(this.defaultUrl);
        }
    }

    setRoute(route, parameters, force) {
        if (!parameters) {
            parameters = {};
        }

        if (force || this.route !== route || !compare(parameters, this.parameters)) {
            if (!this.routes[route]) {
                this.setUrl(this.defaultUrl);
            } else {
                this.route = route;
                this.parameters = parameters;

                url.setPath(this.routes[route], parameters);

                if (this.onChange) {
                    this.onChange(route, parameters);
                }

                this.handleAlias();
            }
        }
    }
}
